import React from 'react';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {getInitialCmsPageSharedValues, PageData, useCmsData} from 'epic-ue-shared';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import UXHeader from '../../components/ux/UXHeader';
import UXContent from '../../components/ux/UXContent';
import Error404 from '../error/Error404';

const cmsUrlPattern = '/ux';

interface UxContent {
    disclaimer: string;
    disclaimerTitle: string;
    items: {
        content: string;
        title: string;
    }[];
}

interface UxPageData extends PageData {
    header: {
        bgColor: string;
        bgImg: string;
        buttons: {
            label: string;
            link: string;
        }[];
        eglogo: string;
        subTitle: string;
        title: string;
        uxTitle: string;
    };
    content: UxContent;
}

const UXView = (): JSX.Element => {
    const {cmsLoading, cmsLoadedEmpty, pageData} = useCmsData<UxPageData>(cmsUrlPattern);

    const headerData = pageData.header || {};
    const contents = pageData.content || ({} as UxContent);
    const items = contents.items || [];

    if (cmsLoading) {
        return <LoadIndicator />;
    }

    if (cmsLoadedEmpty) {
        return <Error404 />;
    }

    return (
        <div id="ux" className="eg-ux">
            {getHelmetForMetaTags(pageData)}
            <UXHeader content={headerData} />

            <div className="ux-content">
                <div className="ux-content-list">
                    {items.map((item) => (
                        <div className="block" key={item.title}>
                            <UXContent content={item} />
                        </div>
                    ))}
                </div>
                <div className="ux-block-bg" />
            </div>
        </div>
    );
};

UXView.getInitialSharedValues = getInitialCmsPageSharedValues(cmsUrlPattern);

export default UXView;
